; (function (inovestor, undefined) {
    // Setup dependencies for this plugin
    // Normally we would add jQuery and knockout but ms-core, which we depend on, already register them so it's useless

    // Create plugin namespace with any desired config variable
    inovestor.ms.stock = inovestor.ms.stock || {};
})(inovestor);


; (function (stock, undefined) {
    // Create plugin namespace with any desired config variable
    stock.summary = {
        config: {
            apiRelativeUrl: 'stocks/companysummary?symbol={symbol}'
        }
    };

})(inovestor.ms.stock);
; (function ($, ko, inovestor, undefined) {
    inovestor.ms.stock.summary.viewModels = {};

    inovestor.ms.stock.summary.viewModels.summaryViewModel = function () {
        var self = this;

        self.summary = ko.observable();
        self.resources = ko.observable();
        self.hasError = ko.observable(false);
        self.isInvalidIdentifier = ko.observable(false);
        self.hasValidData = ko.computed(function () {
            return !self.hasError() && !self.isInvalidIdentifier() && self.summary() != null;
        }, this);

        self.updateResources = function () {
            // Update main resources
            var currentResource = inovestor.ms.stock.summary.resources[inovestor.ms.core.currentLanguage];
            if (inovestor.ms.core.isNullOrUndefined(currentResource))
                currentResource = null;
            self.resources(currentResource);
        };
    }

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function ($, ko, inovestor, undefined) {

    var pluginName = 'inoMsStockSummary';

    // Create the plugin constructor
    function Plugin(element, options) {

        this.element = element;
        this._name = pluginName;
        this._defaults = $.fn.inoMsStockSummary.defaults;
        this._viewModel = new inovestor.ms.stock.summary.viewModels.summaryViewModel();

        // Merge options with defaults
        this.options = $.extend({}, this._defaults, options);

        // Make sure required variables are set
        if (inovestor.ms.core.isNullOrUndefined(this.options.symbol))
            throw "symbol is required";

        // Call init
        this.init();
    }

    $.extend(Plugin.prototype, {

        // Initialization logic
        init: function () {
            var plugin = this;

            // Setup what plugin needs to do on language change
            inovestor.ms.core.instances.register(this, function () {
                plugin.update();
            });

            // Plugin overrides for template = cacheKey and path are the same
            var fileCacheKey = plugin.options.templatePaths.summary;
            var filePath = plugin.options.templatePaths.summary;
            // Default behavior (if no template path is set by plugin)
            if (inovestor.ms.core.isEmptyString(fileCacheKey)) {
                var fileName = 'summary.html';
                fileCacheKey = pluginName + '.' + fileName;
                filePath = (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) ? '' : inovestor.ms.core.config.templateRootUrl) +
                    (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) || inovestor.ms.core.config.templateRootUrl.match(/\/$/) != null ? '' : '/') + // check if templateRootUrl ends in slash
                    (this._name + '/' + fileName);
            }

            // Get main template file
            inovestor.ms.core.getTemplate(fileCacheKey, filePath).then(function (template) {
                $(plugin.element).html(template);
                plugin.buildCache();
                plugin.bindEvents();
                plugin.render();
                plugin.bindModel();
            }).then(function () {
                // Call Search
                plugin.search(plugin.options.symbol).always(function () {
                    // When search is completed, trigger onReady event
                    plugin.$element.trigger('ready' + '.' + plugin._name);
                });
            });
        },

        // Remove plugin instance completely
        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        // Cache DOM nodes for performance
        buildCache: function () {
            this.$element = $(this.element);
        },

        // Bind events that trigger methods
        bindEvents: function () {
            var plugin = this;
            plugin.$element.on('ready' + '.' + plugin._name, function () {
                var onReady = plugin.options.onReady;
                if (typeof onReady === 'function')
                    onReady.call(plugin.$element);
            });
        },

        // Unbind events that trigger methods
        unbindEvents: function () {
            this.$element.off('.' + this._name);
        },

        // API error handler
        apiErrorHandler: function (apiError) {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.apiError, apiError, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.hasError(true);
        },

        // Invalid Identifier error handler
        invalidIdentifierHandler: function () {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.invalidIdentifier, null, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.isInvalidIdentifier(true);
        },

        // Search for a particular stock
        search: function (symbol) {
            var plugin = this;

            // Make sure required variables are set
            if (inovestor.ms.core.isNullOrUndefined(symbol))
                throw "symbol is required";

            // Update options
            plugin.options.symbol = symbol;

            // Setup API url with term
            var stockSummaryUrl = inovestor.ms.core.stringFormat(inovestor.ms.stock.summary.config.apiRelativeUrl, { symbol: symbol });

            // Reset relevant Data before calling API
            plugin._viewModel.summary(null);
            plugin._viewModel.hasError(false);
            plugin._viewModel.isInvalidIdentifier(false);



            // Call API and bind model
            var options = { type: 'GET', contentType: 'application/json', error: function (error) { plugin.apiErrorHandler(error); } };
            return inovestor.ms.core.ajaxApi(stockSummaryUrl, options).then(function (data) {
                if (!inovestor.ms.core.isNullOrUndefined(data)) {
                    if (data.requestStatus === 'invalidIdentifier')
                        plugin.invalidIdentifierHandler();
                    plugin._viewModel.summary(data);
                }
                plugin.update();
            });
        },

        // Renders html template and binds model (should be called once)
        render: function () {
            var plugin = this;
            plugin._viewModel.updateResources();
        },

        // Update resources 
        update: function () {
            var plugin = this;
            // Update view model resources
            plugin._viewModel.updateResources();
            plugin._viewModel.summary.valueHasMutated();
        },

        // Applies knockout bindings to element. (Should be done only once)
        bindModel: function () {
            var plugin = this;
            ko.applyBindings(plugin._viewModel, plugin.element);
        },
    });

    // JQuery Plugin wrapper
    $.fn.inoMsStockSummary = function (options) {
        this.each(function () {
            if (!$.data(this, pluginName)) {
                // Store instance of plugin in "$.data"
                $.data(this, pluginName, new Plugin(this, options));
            }
        });

        // return plugin to support JQuery chaining
        return this;
    };

    // Default options for plugin
    $.fn.inoMsStockSummary.defaults = {
        symbol: null,
        onError: null,
        onReady: null,
        templatePaths: {
            summary: null
        }
    };

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function (stock, undefined) {
    stock.summary.resources = stock.summary.resources || {};
    stock.summary.resources["en"] = {
        asOf: 'As of',
        beta: 'Beta',
        betaInfo: 'Volatility relative to the market',
        bidAsk: 'Bid / Ask',
        dataDelayedBy: 'Data delayed by {minutes} minutes',
        dataRealTime: 'Real-time data',
        dayRange: 'Day Range',
        dividend: 'Expected Dividend (yield)',
        earningsPerShareTTM: 'Earnings / Share',
        fiftyTwoWeek: '52-Week Range',
        institutionalOwnership: 'Institutional Ownership',
        marketCap: 'Market Cap',
        previousClose: 'Previous Close',
        priceToEarningsRatioTTM: 'Price / Earnings Ratio',
        sharesOutstanding: 'Shares Outstanding',
        volume: 'Vol / Avg',
        forShareClass: 'For this share class'
    };
})(inovestor.ms.stock);
; (function (stock, undefined) {
    stock.summary.resources = stock.summary.resources || {};
    stock.summary.resources["fr"] = {
        asOf: 'Au',
        beta: 'Beta',
        betaInfo: 'Volatilité relative au marché',
        bidAsk: 'Cours achet. / Cours vend.',
        dataDelayedBy: 'Données différées de {minutes} minutes',
        dataRealTime: 'Données en temps réel',
        dayRange: 'Var. jour',
        dividend: 'Div. prévu (rendement)',
        earningsPerShareTTM: 'Bénéfice par action',
        fiftyTwoWeek: 'Var. 52 semaines',
        institutionalOwnership: 'Actionnaires institutionnels',
        marketCap: 'Capitalisation Boursière',
        previousClose: 'Clôture',
        priceToEarningsRatioTTM: 'Ratio cours/bénéfice',
        sharesOutstanding: 'Actions en Circulation',
        volume: 'Vol / Moy.',
        forShareClass: 'Pour cette classe d\'actions'
    };
})(inovestor.ms.stock);
